import '@site/styles/sass/styles.scss';

import './vendor/element-closest.js';

import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

import './module/lib/lastContent.js';
import './module/lib/screenReader.js';

import './module/menu.js';
import './module/breadcrumb.js';
// import './module/video';
import './module/carousel.js';
import './module/scroll.js';
import './module/accordion.js';
import './module/stickysidebar.js';
// Note: select.js must put before form.js
import './module/select.js';
import './module/form.js';
import './module/createInternalAnchorLinks.js';
import './module/tabs.js';
import './module/propertyUpgrades.js';


import Menubar from './module/menubar/MenubarLinks.js';
const mtMenuBar = new Menubar(document.getElementById('top-nav-menubar'));
if (mtMenuBar) {
    mtMenuBar.init();
}

const printBtn = document.querySelector('.js-print');
if (printBtn) {
    printBtn.addEventListener('click', function (e) {
        e.preventDefault();
        window.print();
    });
}

/* added _blank for all external links */
const allLinks = document.querySelectorAll('[href^=http]');
for(let linkElem of allLinks) {
    if(linkElem.href.indexOf(window.location.hostname) < 0) {
        linkElem.setAttribute('target', '_blank');
    }
}

const copyLink = document.querySelector('.js-copy-link');
if (copyLink) {
    copyLink.addEventListener('click', function (e) {
        e.preventDefault();
        const cb = navigator.clipboard;
        cb.writeText(window.location.href).then(() => alert('Link copied'));
    });
}